export default __webpack_public_path__ + "static/media/bdswissGlobalReal_downloadMT5.f959a8f6.png";